var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1996 0.600098C9.53687 0.600098 8.99961 1.13736 8.99961 1.8001C8.99961 2.46284 9.53687 3.0001 10.1996 3.0001H13.3026L5.75108 10.5516C5.28245 11.0202 5.28245 11.78 5.75108 12.2486C6.21971 12.7173 6.97951 12.7173 7.44814 12.2486L14.9996 4.69716V7.8001C14.9996 8.46285 15.5369 9.0001 16.1996 9.0001C16.8624 9.0001 17.3996 8.46285 17.3996 7.8001V1.8001C17.3996 1.13736 16.8624 0.600098 16.1996 0.600098H10.1996Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99961 3.0001C1.67413 3.0001 0.599609 4.07462 0.599609 5.4001V15.0001C0.599609 16.3256 1.67413 17.4001 2.99961 17.4001H12.5996C13.9251 17.4001 14.9996 16.3256 14.9996 15.0001V11.4001C14.9996 10.7374 14.4624 10.2001 13.7996 10.2001C13.1369 10.2001 12.5996 10.7374 12.5996 11.4001V15.0001H2.99961V5.4001L6.59961 5.4001C7.26235 5.4001 7.79961 4.86284 7.79961 4.2001C7.79961 3.53736 7.26235 3.0001 6.59961 3.0001H2.99961Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.38fd0bf7b5db88fe1beeb0fdfe652537.svg";
export { ForwardRef as ReactComponent };